import { FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { FormListeners } from '../../../models/beans/form-listeners.abstract';
import { Revisione53State } from '../../../store/revisione53.reducers';
import { setAltreNotLibriSocBloccoSemestraleListeners } from './altre-not-libri-soc-blocco-semestrale.listeners';

export class AltreNotLibriSocFormListeners extends FormListeners {
    private readonly store: Store<Revisione53State>;

    constructor(form: FormGroup, store: Store<Revisione53State>) {
        super(form);
        this.store = store;
    }

    setListeners(): void {
        setAltreNotLibriSocBloccoSemestraleListeners(this.form, this.store);
    }
}
